import Vue from 'vue'

Vue.mixin({
    computed: {
        locale () {
            return process.env.locale
        }
    }
})
